import React from 'react'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'

const LoadingView = () => {
  return (
    <TableStatus status='LOADING'/>
  )
}

export default LoadingView